import { SortableHandle } from 'react-sortable-hoc';
import React from 'react';
import { MenuOutlined } from '@ant-design/icons/lib';

export const DragHandle = SortableHandle(() => <MenuOutlined className="cursor-pointer" />);
